import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from '@assets/svgs/check-icon.svg';
import SmallCrossIcon from '@assets/svgs/cross-small-icon.svg';
import styles from './Validation.module.scss';

enum ValidationState {
  Neutral = 'neutral',
  Valid = 'valid',
  Invalid = 'invalid',
}

type ValidationProps = {
  valid?: boolean;
  text: string;
};

const validationIcon: { [key in ValidationState]: React.ReactNode } = {
  [ValidationState.Neutral]: <></>,
  [ValidationState.Valid]: <CheckIcon className={styles.icon} data-testid="success-icon" />,
  [ValidationState.Invalid]: <SmallCrossIcon className={styles.icon} data-testid="fail-icon" />,
};

const Validation: React.FC<ValidationProps> = ({ valid, text }) => {
  const state = (() => {
    if (valid === undefined || valid === null) return ValidationState.Neutral;
    if (valid) return ValidationState.Valid;
    return ValidationState.Invalid;
  })();

  return (
    <div key={text} className={`${styles.validation} ${styles[state]}`}>
      {validationIcon[state]}
      <span className="small-body-text">{text}</span>
    </div>
  );
};

Validation.propTypes = {
  valid: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

Validation.defaultProps = {
  valid: undefined,
};

export default Validation;
